<template>
  <div class="min-h-screen pt-24 md:pt-28">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <router-link to="/" class="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium mb-6">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>
        Volver al inicio
      </router-link>
      <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12">
        <h1 class="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-4">Términos y Condiciones</h1>
        <p class="text-sm text-gray-500 mb-8">Última actualización: mayo de 2026</p>
        <div class="prose prose-gray max-w-none">
          <p class="text-gray-600 mb-6">
            Se ofrece este sitio web, incluyendo toda información, herramienta y servicio disponible en este sitio para usted, el usuario, condicionado en la aceptación de todos los términos, condiciones, políticas y avisos aquí establecidos. Al visitar este sitio o usar este servicio, acepta los Términos y condiciones de servicio que aquí se detallan.
          </p>

          <p class="text-gray-600 mb-6">
            Toda herramienta agregada al servicio estará sujeta a estos términos y condiciones. Podrá ver la versión más actual de los términos y condiciones en cualquier momento en ésta página. Prio se reserva el derecho de actualizar, cambiar o reemplazar cualquier parte de estos Términos y Condiciones haciendo actualizaciones y/o cambios al sitio. Es su responsabilidad como usuario revisar ésta página periódicamente por cambios. Su uso continuo o acceso al sitio y/o servicio constituye una aceptación de esos cambios.
          </p>

          <div class="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
            <p class="text-amber-800 text-sm font-medium">
              CUALQUIER PERSONA QUE NO ACEPTE ESTOS TÉRMINOS Y CONDICIONES GENERALES, LOS CUALES TIENEN UN CARÁCTER OBLIGATORIO Y VINCULANTE, DEBERÁ ABSTENERSE DE UTILIZAR EL SITIO Y/O LOS SERVICIOS.
            </p>
          </div>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">1. Términos de Usuarios</h2>
          <p class="text-gray-600 mb-4">
            Al aceptar estos Términos y Condiciones de servicio declara que usted es mayor de edad en su país, estado o provincia de residencia, o que usted es mayor de edad en su país, estado o provincia de residencia y nos da su consentimiento permitiendo que cualquiera de sus dependientes menores use este sitio.
          </p>
          <p class="text-gray-600 mb-4">
            Usted no puede utilizar este servicio para ningún propósito ilegal o no autorizado, ni puede, en el uso del Servicio, violar cualquier ley en su jurisdicción.
          </p>
          <p class="text-gray-600 mb-6">
            Prio se reserva el derecho de rechazar una solicitud de registro o de cancelar o suspender, temporal o definitivamente una cuenta, en caso de detectar incongruencias o inconsistencias en la información provista por el Usuario o en caso de detectar actividades sospechosas, sin que tal decisión genere para el Usuario derechos de indemnización o resarcimiento.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">2. Condiciones Generales</h2>
          <p class="text-gray-600 mb-4">
            Prio se reserva el derecho de rechazar el servicio a cualquier persona por cualquier motivo en cualquier momento.
          </p>
          <p class="text-gray-600 mb-4">
            Usted entiende que su contenido puede ser transferido sin cifrar e involucrar transmisiones a través de varias redes y cambios para adaptar y adaptarse a los requisitos técnicos de conexión de redes o dispositivos.
          </p>
          <p class="text-gray-600 mb-4">
            Usted se compromete a no reproducir, duplicar, copiar, vender, revender o explotar ninguna parte del Servicio, el uso del Servicio, o el acceso al Servicio o cualquier contacto en el sitio web a través del cual se presta el servicio, sin el permiso expreso por escrito por la persona a cargo de prio.ar.
          </p>
          <p class="text-gray-600 mb-6">
            Los encabezados utilizados en este acuerdo se incluyen sólo por conveniencia y no limitarán ni afectarán de ninguna otra manera estos Términos.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">3. Modificaciones al Servicio y Precios</h2>
          <p class="text-gray-600 mb-4">
            Los precios y/o tarifas del servicio están sujetos a cambios sin previo aviso.
          </p>
          <p class="text-gray-600 mb-4">
            Prio se reserva el derecho de modificar o discontinuar el Servicio (o cualquier parte o contenido del mismo) sin previo aviso en cualquier momento.
          </p>
          <p class="text-gray-600 mb-6">
            No somos responsables ante usted o terceros por cualquier modificación, cambio de precio, suspensión o discontinuación del Servicio.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">4. Descripción del Servicio</h2>
          <p class="text-gray-600 mb-4">
            Prio es una plataforma de gestión de presupuestos impulsada por inteligencia artificial que permite a profesionales y pequeñas empresas:
          </p>
          <ul class="list-disc pl-5 text-gray-600 mb-6 space-y-2">
            <li>Crear y gestionar presupuestos profesionales de manera rápida</li>
            <li>Utilizar un asistente de IA para generar presupuestos mediante chat de texto o voz</li>
            <li>Gestionar un catálogo de servicios y productos</li>
            <li>Mantener una base de datos de clientes</li>
            <li>Recibir consultas de potenciales clientes mediante formularios personalizados</li>
            <li>Enviar presupuestos a clientes y recibir aprobaciones en línea</li>
            <li>Acceder a analytics y estadísticas de sus presupuestos</li>
            <li>Integrar con Telegram para gestión mediante chat</li>
          </ul>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">5. Suscripción y Pagos</h2>
          <p class="text-gray-600 mb-4">
            Prio ofrece un período de prueba gratuito de 30 días. Pasado este período, el uso continuo del servicio requiere una suscripción de pago mensual.
          </p>
          <ul class="list-disc pl-5 text-gray-600 mb-6 space-y-2">
            <li>Los precios de las suscripciones están detallados en la <router-link to="/#pricing" class="text-primary-600 hover:underline">página de precios</router-link> y pueden estar sujetos a cambios. El precio vigente al momento de la contratación será el aplicable.</li>
            <li>Los pagos se procesan a través de MercadoPago</li>
            <li>La suscripción se renueva automáticamente cada mes</li>
            <li>Podés cancelar tu suscripción en cualquier momento desde la configuración de tu cuenta</li>
            <li>Al cancelar, mantendrás acceso hasta el final del período pagado</li>
            <li>No se realizan reembolsos por períodos parciales del mes</li>
          </ul>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">6. Actividades Prohibidas</h2>
          <p class="text-gray-600 mb-4">
            Usted no debe usar el servicio de Prio para actividades que:
          </p>
          <ul class="list-disc pl-5 text-gray-600 mb-6 space-y-2">
            <li>Violeen cualquier ley, estatuto, orden o regulación de la República Argentina</li>
            <li>Se relacionen con transacciones que involucren productos o servicios ilegales, fraudulentos o que presenten riesgo para la seguridad del consumidor</li>
            <li>Incluyan contenido que fomente el odio, la violencia, la discriminación racial u otras formas de intolerancia</li>
            <li>Infrinjan o violen derechos de autor, marcas comerciales, derechos de publicidad o privacidad</li>
            <li>Involucren spam, phishing o cualquier forma de comunicación no solicitada</li>
            <li>Intenten acceder sin autorización a sistemas o datos de terceros</li>
            <li>Utilicen la plataforma para almacenar datos sensibles de terceros sin consentimiento</li>
          </ul>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">7. Propiedad Intelectual</h2>
          <p class="text-gray-600 mb-4">
            Todo el contenido de la Plataforma, incluyendo pero no limitado a textos, gráficos, logos, íconos, imágenes, clips de audio, descargas digitales y software, es propiedad de Prio o de sus proveedores de contenido y está protegido por las leyes argentinas de propiedad intelectual (Ley 11.723).
          </p>
          <p class="text-gray-600 mb-4">
            Los usuarios conservan la propiedad de su contenido cargado en la plataforma (datos de clientes, presupuestos, catálogo), pero otorgan a Prio una licencia limitada para procesar dicho contenido con el fin de proporcionar los servicios contratados, incluyendo el procesamiento mediante proveedores de IA de terceros.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">8. Proveedores Terceros y Cesión de Datos</h2>
          <p class="text-gray-600 mb-4">
            En cumplimiento del Artículo 11 de la Ley 25.326 de Protección de Datos Personales, se informa que para la prestación del servicio Prio utiliza los siguientes proveedores terceros que acceden a datos personales:
          </p>

          <div class="overflow-x-auto mb-4">
            <table class="min-w-full border-collapse border border-gray-200 text-sm">
              <thead>
                <tr class="bg-gray-50">
                  <th class="border border-gray-200 px-4 py-2 text-left font-semibold">Proveedor</th>
                  <th class="border border-gray-200 px-4 py-2 text-left font-semibold">Servicio</th>
                  <th class="border border-gray-200 px-4 py-2 text-left font-semibold">Ubicación</th>
                  <th class="border border-gray-200 px-4 py-2 text-left font-semibold">Datos accedidos</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="border border-gray-200 px-4 py-2">MercadoPago S.A.</td>
                  <td class="border border-gray-200 px-4 py-2">Procesamiento de pagos</td>
                  <td class="border border-gray-200 px-4 py-2">Argentina</td>
                  <td class="border border-gray-200 px-4 py-2">Nombre, email, datos de pago</td>
                </tr>
                <tr class="bg-gray-50">
                  <td class="border border-gray-200 px-4 py-2">Resend Inc.</td>
                  <td class="border border-gray-200 px-4 py-2">Envío de emails</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Dirección de email</td>
                </tr>
                <tr>
                  <td class="border border-gray-200 px-4 py-2">Deepgram Inc.</td>
                  <td class="border border-gray-200 px-4 py-2">Transcripción de voz</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Audio grabado por el usuario</td>
                </tr>
                <tr class="bg-gray-50">
                  <td class="border border-gray-200 px-4 py-2">Google LLC (via OpenRouter)</td>
                  <td class="border border-gray-200 px-4 py-2">Modelo de IA</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Texto de consultas del usuario</td>
                </tr>
                <tr>
                  <td class="border border-gray-200 px-4 py-2">Microsoft Corporation</td>
                  <td class="border border-gray-200 px-4 py-2">Analytics (Clarity)</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Comportamiento de navegación</td>
                </tr>
                <tr class="bg-gray-50">
                  <td class="border border-gray-200 px-4 py-2">Google LLC</td>
                  <td class="border border-gray-200 px-4 py-2">Analytics (Google Analytics)</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Datos de navegación</td>
                </tr>
                <tr>
                  <td class="border border-gray-200 px-4 py-2">Google LLC</td>
                  <td class="border border-gray-200 px-4 py-2">Almacenamiento de imágenes</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Imágenes subidas por el usuario</td>
                </tr>
                <tr class="bg-gray-50">
                  <td class="border border-gray-200 px-4 py-2">Google LLC</td>
                  <td class="border border-gray-200 px-4 py-2">Autenticación (OAuth)</td>
                  <td class="border border-gray-200 px-4 py-2">EE.UU.</td>
                  <td class="border border-gray-200 px-4 py-2">Nombre, email, foto de perfil</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p class="text-gray-600 mb-4">
            La transferencia de datos a proveedores ubicados en Estados Unidos se realiza con el consentimiento expreso del titular, conforme al Artículo 12 de la Ley 25.326. El detalle completo del tratamiento de datos personales se encuentra en nuestra <router-link to="/privacidad" class="text-primary-600 hover:underline">Política de Privacidad</router-link>.
          </p>
          <p class="text-gray-600 mb-6">
            Todos los proveedores cuentan con contratos de encargo de tratamiento que garantizan niveles adecuados de protección de datos.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">9. Privacidad y Protección de Datos</h2>
          <p class="text-gray-600 mb-6">
            El uso de datos personales está regulado por nuestra <router-link to="/privacidad" class="text-primary-600 hover:underline">Política de Privacidad</router-link> y por la Ley 25.326 de Protección de Datos Personales de Argentina. Al utilizar el servicio, aceptas el tratamiento de tus datos según lo establecido en dicha política.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">10. Limitación de Responsabilidad</h2>
          <p class="text-gray-600 mb-4">
            La Plataforma se proporciona "tal cual" y "según disponibilidad". Prio no garantiza que:
          </p>
          <ul class="list-disc pl-5 text-gray-600 mb-4 space-y-2">
            <li>El servicio será ininterrumpido, oportuno, seguro o libre de errores</li>
            <li>Los resultados obtenidos del uso del servicio serán exactos o confiables</li>
            <li>Los errores en el servicio serán corregidos</li>
          </ul>
          <p class="text-gray-600 mb-6">
            En ningún caso Prio será responsable por daños indirectos, incidentales, especiales o consecuentes que resulten del uso o la imposibilidad de usar la Plataforma.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">11. Cancelación y Terminación</h2>
          <p class="text-gray-600 mb-4">
            Podés cancelar tu cuenta en cualquier momento desde la configuración de tu cuenta. Al cancelar, tu acceso se mantendrá hasta el final del período de facturación actual.
          </p>
          <p class="text-gray-600 mb-6">
            Prio se reserva el derecho de suspender o cancelar tu cuenta inmediatamente, sin previo aviso, si determinamos que has violado estos Términos y Condiciones.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">12. Ley Aplicable y Jurisdicción</h2>
          <p class="text-gray-600 mb-6">
            Estos Términos y Condiciones se rigen por las leyes de la República Argentina. Cualquier disputa relacionada con estos términos será sometida a la jurisdicción de los tribunales ordinarios de la Ciudad Autónoma de Buenos Aires, renunciando expresamente a cualquier otro fuero que pudiera corresponder.
          </p>

          <h2 class="font-display text-xl font-bold text-gray-900 mt-8 mb-4">13. Información de Contacto</h2>
          <p class="text-gray-600 mb-4">
            Las preguntas sobre los términos y condiciones deben ser enviadas a:
          </p>
          <ul class="list-none pl-0 text-gray-600 mb-6 space-y-2">
            <li><strong>Email:</strong> hola@prio.ar</li>
            <li><strong>WhatsApp:</strong> +54 9 2254 62-0823</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';
import { useScrollReveal } from '@/composables/useScrollReveal';
useScrollReveal();

useHead({
  title: 'Términos y Condiciones - Prio',
  meta: [
    { name: 'description', content: 'Términos y condiciones de uso de Prio - Tu asistente IA para presupuestos' },
  ],
});
</script>
